class Tarjeta{
    constructor(
        Nombre,
        IdTipoTarjeta,
        Logo,
        ListaDiferidos,
        Cuenta,
    ){
        this.Nombre=Nombre;
        this.IdTipoTarjeta=IdTipoTarjeta;
        this.Logo=Logo;
        this.ListaDiferidos=ListaDiferidos;
        this.Cuenta=Cuenta;
    }
}

export default Tarjeta;